import { render, staticRenderFns } from "./BatteryProductPromo.vue?vue&type=template&id=008e2a38"
import script from "./BatteryProductPromo.vue?vue&type=script&lang=ts"
export * from "./BatteryProductPromo.vue?vue&type=script&lang=ts"
import style0 from "./BatteryProductPromo.vue?vue&type=style&index=0&id=008e2a38&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports